import { render, staticRenderFns } from "./ContrassenhaValidar.vue?vue&type=template&id=2afbd7ae&scoped=true&"
import script from "./ContrassenhaValidar.vue?vue&type=script&lang=js&"
export * from "./ContrassenhaValidar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbd7ae",
  null
  
)

export default component.exports